import { Component, OnInit } from "@angular/core";
import { ClientModel } from "../model/clientModel";
import { NgForm } from "@angular/forms";
import { ClientService } from "../service/client.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-add-client",
  templateUrl: "./add-client.component.html",
  styleUrls: ["./add-client.component.css"],
})
export class AddClientComponent implements OnInit {
  client: ClientModel = {
    DestinationNumber: "",
    DestinationName: "",
    DestinationStatusId: true,
  };

  constructor(private clientService: ClientService, private router: Router) {}

  ngOnInit() {}

  onSubmit(clientForm: NgForm) {
    if (clientForm.valid) {
      console.log("Client data:", this.client);

      this.clientService.addClient(this.client).subscribe(
        (response: any) => {
          // type `any` because it's an object with success/message
          console.log(response);

          if (response.success) {
            alert("הלקוח נוסף בהצלחה!");
            this.router.navigate(["/clientManagment"]);
            clientForm.resetForm();
          } else {
            alert("קרתה שגיאה בהוספת הלקוח: " + (response.message || ""));
          }
        },
        (error) => {
          console.log(error);
          alert("שגיאת שרת");
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/add-client/add-client.component.ts